module.exports = __webpack_public_path__ + "img/paciente2.a9338a22.png";